import * as React from 'react';
import {
  PageSection,
  Title,
  Form,
  FormGroup,
  TextInput,
  DatePicker,
  Grid,
  FormSection,
  Button,
} from '@patternfly/react-core';
import { TResearchPublication } from '@app/config/types';
import { StoreContext } from '@app/store';
import { ADD_RESEARCH_PUBLICATION, ARRAY_CHILD_CHANGE, REMOVE_ITEM_FROM_ARRAY } from '@app/config/constants';

const ResearchPublicationsForm: React.FunctionComponent = () => {
  const { state, dispatch } = React.useContext(StoreContext);
  return (
    <PageSection>
      <Title headingLevel="h1" size="lg">
        My Information
      </Title>
      <Form onSubmit={(e) => e.preventDefault()}>
        {state.research_publications.map((item: TResearchPublication, index) => (
          <FormSection key={index}>
            <Grid hasGutter md={6}>
              <FormGroup label="Title of Publication" isRequired fieldId="simple-form-name-01">
                <TextInput
                  isRequired
                  type="text"
                  id="simple-form-name-01"
                  name="simple-form-name-01"
                  aria-describedby="simple-form-name-01-helper"
                  value={item.title}
                  onChange={(value) =>
                    dispatch({
                      type: ARRAY_CHILD_CHANGE,
                      payload: {
                        key: 'research_publications',
                        index,
                        childKey: 'title',
                        value,
                      },
                    })
                  }
                />
              </FormGroup>
              <FormGroup label="Link to Publication" isRequired fieldId="simple-form-name-02">
                <TextInput
                  isRequired
                  type="text"
                  id="simple-form-name-02"
                  name="simple-form-name-02"
                  aria-describedby="simple-form-name-02-helper"
                  value={item.link}
                  onChange={(value) =>
                    dispatch({
                      type: ARRAY_CHILD_CHANGE,
                      payload: {
                        key: 'research_publications',
                        index,
                        childKey: 'link',
                        value,
                      },
                    })
                  }
                />
              </FormGroup>
              <FormGroup label="Publication Date" isRequired fieldId="simple-form-link-01">
                <DatePicker
                  onChange={(value) =>
                    dispatch({
                      type: ARRAY_CHILD_CHANGE,
                      payload: {
                        key: 'research_publications',
                        index,
                        childKey: 'date',
                        value,
                      },
                    })
                  }
                />
              </FormGroup>
              <Button
                variant="danger"
                onClick={() =>
                  dispatch({
                    type: REMOVE_ITEM_FROM_ARRAY,
                    payload: {
                      key: 'research_publications',
                      index,
                    },
                  })
                }
              >
                Remove
              </Button>
            </Grid>
          </FormSection>
        ))}
        <Button
          variant="primary"
          onClick={() =>
            dispatch({
              type: ADD_RESEARCH_PUBLICATION,
            })
          }
        >
          Add Research Publication / Article
        </Button>
      </Form>
    </PageSection>
  );
};

export { ResearchPublicationsForm };
